import { axiosInstance } from "@/use/utilities/axios/app/axios-instance";

export async function storeAsRejected(precriptionTestId, stateSlug, reasonSlug) {
  const axios = axiosInstance().primoLab;
  let prescriptionRejected = [];

  await axios
    .post(`/prescription-rejections`, {
      prescription_test_id: precriptionTestId,
      state_slug: stateSlug,
      reason_slug: reasonSlug,
    })
    .then(async (response) => {
      prescriptionRejected = response.data.data;
    })
    .catch(async (error) => {
      throw error.response.data.errors;
    });

  return { prescriptionRejected };
}
